import React, { Component } from 'react';

import './index.less';
class index extends Component {
    state = {  }
    render() {
        return (
            <div className="evaluation__footer">
                <p className="service">
                    <span>服务时间：工作日9:00—18:00</span>
                    <i className="line"></i>
                    <span className="phone">400-050-8080转3</span>
                </p>
                <div className="line"></div>
                <p className="copy">
                ICP经营许可证编号  京ICP证060405号  京ICP备10012705号-2  京公网备案信息11010502000809
                </p>
                <p className="copy">
Copyright © 五八信息技术有限公司 版权所有
                </p>
            </div>
        );
    }
}

export default index;